module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "select",
      "name": "Select"
    }
  }, [_c('p', [_vm._v("Based in a "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://silviomoreto.github.io/bootstrap-select/"
    }
  }, [_vm._v("bootstrap-select")]), _vm._v(" implementation.")]), _vm._v(" "), _c('div', {
    staticClass: "bs-example"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('p', [_c('pre', [_vm._v("Normal select data: " + _vm._s(_vm.select.normal))])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "./#select",
      "method": "get"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.select.options,
      "options-value": "val",
      "name": "animal",
      "search": _vm.select.search,
      "required": _vm.select.required,
      "clear-button": _vm.select.clearButton,
      "disabled": _vm.select.disabled,
      "placeholder": _vm.select.placeholder ? 'Using placeholder' : null
    },
    model: {
      value: (_vm.select.normal),
      callback: function($$v) {
        _vm.select.normal = $$v
      },
      expression: "select.normal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('p', [_c('pre', [_vm._v("Multiple select data : " + _vm._s(_vm.select.multiple.join(',')))])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "./#select",
      "method": "get"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.select.options,
      "options-value": "val",
      "name": "animals[]",
      "search": _vm.select.search,
      "multiple": "",
      "required": _vm.select.required,
      "clear-button": _vm.select.clearButton,
      "placeholder": _vm.select.placeholder ? 'Using placeholder' : null,
      "close-on-select": _vm.select.closeOnSelect,
      "limit": _vm.select.limit ? 3 : 1024,
      "disabled": _vm.select.disabled
    },
    model: {
      value: (_vm.select.multiple),
      callback: function($$v) {
        _vm.select.multiple = $$v
      },
      expression: "select.multiple"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button-group', {
    attrs: {
      "type": "primary",
      "buttons": false
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('p', [_c('checkbox', {
    model: {
      value: (_vm.select.disabled),
      callback: function($$v) {
        _vm.select.disabled = $$v
      },
      expression: "select.disabled"
    }
  }, [_vm._v("Disabled")])], 1), _vm._v(" "), _c('p', [_c('checkbox', {
    model: {
      value: (_vm.select.placeholder),
      callback: function($$v) {
        _vm.select.placeholder = $$v
      },
      expression: "select.placeholder"
    }
  }, [_vm._v("Placeholder")])], 1), _vm._v(" "), _c('p', [_c('checkbox', {
    model: {
      value: (_vm.select.search),
      callback: function($$v) {
        _vm.select.search = $$v
      },
      expression: "select.search"
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('p', [_c('checkbox', {
    model: {
      value: (_vm.select.clearButton),
      callback: function($$v) {
        _vm.select.clearButton = $$v
      },
      expression: "select.clearButton"
    }
  }, [_vm._v("Clear Button")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('p', [_c('checkbox', {
    model: {
      value: (_vm.select.required),
      callback: function($$v) {
        _vm.select.required = $$v
      },
      expression: "select.required"
    }
  }, [_vm._v("Required (empty value if noting selected)")])], 1), _vm._v(" "), _c('p', [_vm._v("\n            Multiple:\n            "), (_vm.select.multiple) ? _c('checkbox', {
    model: {
      value: (_vm.select.limit),
      callback: function($$v) {
        _vm.select.limit = $$v
      },
      expression: "select.limit"
    }
  }, [_vm._v("Limit (e.g. 3)")]) : _vm._e(), _vm._v(" "), (_vm.select.multiple) ? _c('checkbox', {
    model: {
      value: (_vm.select.closeOnSelect),
      callback: function($$v) {
        _vm.select.closeOnSelect = $$v
      },
      expression: "select.closeOnSelect"
    }
  }, [_vm._v("Close on Select")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('doc-code', [_vm._v("\n      <form action=\"./#select\" method=\"get\">\n        <v-select v-model=\"select.value\" :options=\"select.options\" options-value=\"val\"\n          multiple name=\"animals[]\" limit=\"3\"\n          placeholder=\"Using placeholder\"\n          search justified required disabled\n          clear-button close-on-select\n        ></v-select>\n        <button type=\"submit\" class=\"btn btn-default\">Submit form</button>\n      </form>\n    ")]), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "javascript"
    }
  }, [_vm._v("\n      options: [\n        {val: 0, label: 'Cat'},\n        {val: 1, label: 'Cow'},\n        {val: 2, label: 'Dog'},\n        {val: 3, label: 'Elephant'},\n        {val: 4, label: 'Fish'},\n        {val: 5, label: 'Lion'},\n        {val: 6, label: 'Tiger'},\n        {val: 7, label: 'Turtle'}\n      ]\n    ")]), _vm._v(" "), _c('h4', [_vm._v("Select with option component:")]), _vm._v(" "), _c('p', [_c('pre', [_vm._v("Selected data : " + _vm._s(_vm.single))])]), _vm._v(" "), _c('v-select', {
    model: {
      value: (_vm.single),
      callback: function($$v) {
        _vm.single = $$v
      },
      expression: "single"
    }
  }, [_c('v-option', {
    attrs: {
      "value": "apple"
    }
  }, [_vm._v("Apple")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "banana"
    }
  }, [_vm._v("Banana")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "cherry"
    }
  }, [_vm._v("Cherry")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "orange"
    }
  }, [_vm._v("Orange")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "grape"
    }
  }, [_vm._v("Grape")])], 1), _vm._v(" "), _c('doc-code', [_vm._v("\n      <v-select>\n        <v-option value=\"apple\">Apple</v-option>\n        <v-option value=\"banana\">Banana</v-option>\n        <v-option value=\"cherry\">Cherry</v-option>\n        <v-option value=\"orange\">Orange</v-option>\n        <v-option value=\"grape\">Grape</v-option>\n      </v-select>\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Use button-group (component or "), _c('a', {
    attrs: {
      "href": "http://getbootstrap.com/components/#btn-groups-justified"
    }
  }, [_vm._v("bootstrap element")]), _vm._v(") if you want to justify.")]), _vm._v(" "), _c('button-group', {
    attrs: {
      "justified": ""
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "clear-button": ""
    }
  }, [_c('v-option', {
    attrs: {
      "value": "apple"
    }
  }, [_vm._v("Apple")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "banana"
    }
  }, [_vm._v("Banana")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "cherry"
    }
  }, [_vm._v("Cherry")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "cranberry"
    }
  }, [_vm._v("Cranberry")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "grape"
    }
  }, [_vm._v("Grape")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "orange"
    }
  }, [_vm._v("Orange")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "passionfruit"
    }
  }, [_vm._v("Passionfruit")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "pineapple"
    }
  }, [_vm._v("Pineapple")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "strawberry"
    }
  }, [_vm._v("Strawberry")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "a"
    }
  }, [_vm._v("Apple")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "b"
    }
  }, [_vm._v("Banana")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "c"
    }
  }, [_vm._v("Cherry")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "c"
    }
  }, [_vm._v("Cranberry")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "g"
    }
  }, [_vm._v("Grape")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "o"
    }
  }, [_vm._v("Orange")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "p"
    }
  }, [_vm._v("Passionfruit")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "p"
    }
  }, [_vm._v("Pineapple")]), _vm._v(" "), _c('v-option', {
    attrs: {
      "value": "s"
    }
  }, [_vm._v("Strawberry")])], 1)], 1), _vm._v(" "), _c('doc-code', [_vm._v("\n      <button-group justified><select>...</select></button-group>\n      // or\n      <div class=\"btn-group btn-group-justified\"><select>...</select></div>\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Ajax data and parent dependency:")]), _vm._v(" "), _c('p', [_vm._v("Depend on "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes"
    }
  }, [_vm._v("vue-resource")]), _vm._v(". Disabled if not present.")]), _vm._v(" "), _c('p', [_vm._v("The second select has inheritance, is enabled when the first get some value and the ajax return values.")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "url": "docs/data.json",
      "options-label": "text",
      "clear-button": ""
    },
    on: {
      "options": function($event) {
        _vm.ajax.options = arguments[0]
      }
    },
    model: {
      value: (_vm.ajax.value),
      callback: function($$v) {
        _vm.ajax.value = $$v
      },
      expression: "ajax.value"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "url": "docs/data.json",
      "options-label": "text",
      "multiple": "",
      "parent": _vm.ajax.value
    }
  }), _vm._v(" "), _c('doc-code', [_vm._v("\n      <v-select url=\"docs/data.json\" options-label=\"text\" v-model=\"ajax.value\" clear-button @options=\"ajax.options = arguments[0]\"></v-select>\n      <v-select url=\"docs/data.json\" options-label=\"text\" multiple :parent=\"ajax.value\"></v-select>\n    ")]), _vm._v(" "), _c('p', [_vm._v("Ajax response:")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.ajax.options)
    }
  })], 1), _vm._v(" "), _c('doc-table', {
    attrs: {
      "name": "Other"
    }
  }, [_c('div', [_c('p', [_vm._v("min-search")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("0")])]), _vm._v(" "), _c('p', [_vm._v("If defined, the searchbox is disabled if are less than the minimum value you set.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("lang")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p', [_vm._v("Browser language")]), _vm._v(" "), _c('p', [_c('abbr', {
    attrs: {
      "title": "ISO 639-1 code"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes"
    }
  }, [_vm._v("Language")])]), _vm._v(". Default "), _c('code', [_vm._v("en")]), _vm._v(" if the translation doesn't exist.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("options-label")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("label")])]), _vm._v(" "), _c('p', [_vm._v("Define the value in the data used as label.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("options-value")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("value")])]), _vm._v(" "), _c('p', [_vm._v("Define the value in the data used as value.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("placeholder")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p', [_vm._v("Nothing Selected")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("search-text")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('doc-table', {
    attrs: {
      "type": "Events"
    }
  }, [_c('div', [_c('p', [_vm._v("change")]), _vm._v(" "), _c('p', [_vm._v("("), _c('code', [_vm._v("value")]), _vm._v(")")]), _vm._v(" "), _c('p', [_vm._v("Return the selected value(s).")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("options")]), _vm._v(" "), _c('p', [_vm._v("("), _c('code', [_vm._v("options:Array")]), _vm._v(")")]), _vm._v(" "), _c('p', [_vm._v("Return the options array. Helpfull for dinamic/url options.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("selected")]), _vm._v(" "), _c('p', [_vm._v("("), _c('code', [_vm._v("labels:String")]), _vm._v(")")]), _vm._v(" "), _c('p', [_vm._v("Return a string with the label(s) of the selected item(s).")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72db5302", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72db5302!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/selectDocs.vue
// module id = 255
// module chunks = 0